export const GROUP_TYPES = {
  DIMENSIONS: 'Dimensions',
  DETAILS: 'Details',
  WARRANTY: 'Warranty / Certifications'
};
export const ITEM_CLICKED_EVENT = 'specifications.itemClicked';

export const CONFIGURATOR_ITEM_IDS_EVENT = 'configurator.item_ids';

export const isEventBusCreated = () => {
  return typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS;
};

export const getCommaSpaceValue = (specValue) => {
  const specContainsComma = /[a-zA-Z0-9$](,)[a-zA-Z0-9$]/;
  const spacedSpecValue = !specContainsComma.test(specValue)
    ? specValue : specValue.replace(/,/g, ', ');
  return spacedSpecValue;
};

export const getSortedValue = ({ attributeGroupList }) => (
  (attributeGroupList?.specifications || [])
    .map((attr) => {
      const newAttr = { ...attr };
      newAttr.specValue = getCommaSpaceValue(newAttr?.specValue);
      return newAttr;
    })
    .filter((attr) => attr.specName)
    .sort((entryName, compName) => {
      const nameval1 = entryName.specName.toUpperCase();
      const nameval2 = compName.specName.toUpperCase();
      if (nameval1 < nameval2) return -1;
      if (nameval1 > nameval2) return 1;
      return 0;
    }));

export const getRows = ({ attributeGroupList, rowSize = 2 }) => {
  const attributeValues = getSortedValue({ attributeGroupList });
  if (attributeValues.length > 0) {
    return attributeValues.reduce((values = [], item, index) => {
      const chunkIndex = Math.floor(index / rowSize);
      const newItem = { ...item };
      newItem.specValue = getCommaSpaceValue(newItem?.specValue);
      const rowArray = values;

      if (!values[chunkIndex]) {
        rowArray[chunkIndex] = [];
      }

      rowArray[chunkIndex].push(newItem);
      return rowArray;
    }, []);
  }
  return [];
};

export const getProductImage = (ProductImages) => {
  if (!ProductImages) {
    return '';
  }
  const primaryImage = ProductImages?.find((image) => image?.subType === 'PRIMARY');
  const primaryImageUrl = primaryImage?.url;
  const setImages = primaryImage?.sizes.map((size) => primaryImageUrl.replace(/<SIZE>/i, size));
  const mainImage = setImages[3];
  return mainImage;
};
export const triggerAnalyticsCustomEvent = (eventName, data) => {
  if (isEventBusCreated()) {
    window.LIFE_CYCLE_EVENT_BUS.trigger(eventName, data);
  }
};

export const getDdo = (product, component) => {
  return {
    section: 'zone-b',
    component,
    target: product?.identifiers?.productLabel
  };
};

export const changeSelectedItem = (itemId) => {
  // For Specifications Title component that has already been loaded
  LIFE_CYCLE_EVENT_BUS.trigger(ITEM_CLICKED_EVENT, { itemId });
};
